import { Component, Input, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "greeting",
  template: `
    <div *ngIf="data.length <= 0">
      <div class="row">
        <div class="col-sm-12">
          <div class="text-center error-box">
            <h2 class="font-xl">
              <strong>
                <i class="fa fa-fw fa-warning fa-lg text-warning"></i> Records
                <u>not</u> found
              </strong>
            </h2>
            <br />
            <p class="lead">
              We are sorry but in our database we do not have any records that
              match your search.
            </p>
            <p class="font-md">
              <b>......Try another query in the search engine</b>
            </p>
            <br />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="data.length > 0">
      <div [ngSwitch]="type">
        <pi
          *ngSwitchCase="'pi'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></pi>
        <myleads
          *ngSwitchCase="'myleads'"
          [data]="data"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></myleads>
        <list-items
          *ngSwitchCase="'list-items'"
          [data]="data"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></list-items>
        <internallocations
          *ngSwitchCase="'internallocations'"
          [data]="data"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></internallocations>
        <list-scraps
          *ngSwitchCase="'list-scraps'"
          [data]="data"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></list-scraps>
        <proposal
          *ngSwitchCase="'proposal'"
          [data]="data"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></proposal>
        <container
          *ngSwitchCase="'container'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          [bulk]="bulk"
          (change)="setBulk($event)"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></container>
        <scraps
          *ngSwitchCase="'scraps'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          [bulk]="bulk"
          (change)="setBulk($event)"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></scraps>
        <tickets
          *ngSwitchCase="'tickets'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></tickets>
        <scraps-progress
          *ngSwitchCase="'scraps-progress'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          [bulk]="bulk"
          (change)="setBulk($event)"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></scraps-progress>
        <scraps-completed
          *ngSwitchCase="'scraps-completed'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          [bulk]="bulk"
          (change)="setBulk($event)"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></scraps-completed>
        <scraps-shipped
          *ngSwitchCase="'scraps-shipped'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          [bulk]="bulk"
          (change)="setBulk($event)"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></scraps-shipped>
        <virtual-container
          *ngSwitchCase="'virtualContainer'"
          [data]="data"
          [order]="order"
          [orderby]="orderby"
          [bulk]="bulk"
          (change)="setBulk($event)"
          (sortby)="sort($event)"
          table_id="{{ table_id }}"
          (out)="send($event)"
        ></virtual-container>
      </div>
    </div>
  `,
})
export class GreetingSelectorComponent {
  @Input() type: string;
  @Input() table_id: string;
  @Input() data;
  @Input() order;
  @Input() orderby;
  @Input() bulk: number[] = [];
  @Output() changeBulk: EventEmitter<any>;
  @Output() out: EventEmitter<any>;
  @Output() sortby: EventEmitter<any>;

  constructor() {
    this.changeBulk = new EventEmitter();
    this.out = new EventEmitter();
    this.sortby = new EventEmitter();
  }

  send(e) {
    this.out.emit(e);
  }

  sort(e) {
    this.sortby.emit(e);
  }

  setBulk(e) {
    this.bulk = e;
    this.changeBulk.emit(e);
  }
}
